import { useUsers } from '../../data/useUsers';
import { useT } from '../../i18n/I18nProvider';

/**
 * The last crumb on `/users/:id`, mirroring `TenantCrumb`.
 *
 * The trail said "Details" for every user, so two tabs open on two different
 * people looked identical. The name comes from the users list the console
 * already caches; until it lands, or for a user the list does not carry, the
 * crumb falls back to "Details", which is at least true.
 */
export function UserCrumb({ id }: { id: string }) {
  const t = useT();
  const { data } = useUsers();
  const user = (data?.data ?? []).find((u) => u.id === id);
  const name = user?.display_name || user?.email;
  return <>{name || t('shell.breadcrumb.details')}</>;
}
